import { component } from "picoapp";

export const contactForm = component((node: HTMLFormElement) => {
  function handleSubmit(event: SubmitEvent & { target: HTMLFormElement }) {
    event.preventDefault();
    const data = new FormData(event.target);
    fetch("https://formspree.io/f/mleyekaw", {
      method: "post",
      body: data,
      headers: {
        Accept: "application/json",
      },
    })
      .then((response) => {
        if (response.ok) {
          const formWrapper = document.querySelector<HTMLElement>(
            ".js-contact-form-wrapper"
          );
          const formHeader = document.querySelector<HTMLElement>(
            ".js-contact-form-header"
          );
          const successMessage = document.querySelector<HTMLElement>(
            ".js-contact-form-success"
          );
          formWrapper.classList.add("tw-hidden");
          formHeader.classList.add("tw-hidden");
          successMessage.classList.remove("tw-hidden");
          event.target.reset();
          successMessage.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        } else {
          const formErrorWrapper =
            document.querySelector<HTMLElement>(".js-form-error");
          const formError =
            document.querySelector<HTMLParagraphElement>(".js-form-error > p");
          formErrorWrapper.classList.remove("tw-hidden");
          formError.innerHTML =
            "There was an error submitting your form. Please try again.";
        }
      })
      .catch(() => {
        const formErrorWrapper =
          document.querySelector<HTMLElement>(".js-form-error");
        const formError = document.querySelector<HTMLElement>(".js-form-error");
        formErrorWrapper.classList.remove("tw-hidden");
        formError.innerHTML =
          "There was an error submitting your form. Please try again.";
      });
  }
  node.addEventListener("submit", handleSubmit);
  return () => {
    node.removeEventListener("submit", handleSubmit);
  };
});
